import { render, staticRenderFns } from "./ProductRecall.vue?vue&type=template&id=25f4b456&scoped=true"
import script from "./ProductRecall.vue?vue&type=script&lang=js"
export * from "./ProductRecall.vue?vue&type=script&lang=js"
import style0 from "./ProductRecall.vue?vue&type=style&index=0&id=25f4b456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4b456",
  null
  
)

export default component.exports